import { createSlice } from '@reduxjs/toolkit';
import NotifyMessageNoReload from '../../Component/Others/NotifyMessageNoReload';

const loadCartFromStorage = () => {
  try {
    const cartData = localStorage.getItem('redux_cart');
    return cartData ? JSON.parse(cartData) : [];
  } catch (err) {
    console.error("Cart load error:", err);
    NotifyMessageNoReload("Failed to load cart data", "danger", true);
    return [];
  }
};

const initialState = {
  items: loadCartFromStorage(),
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const existingItem = state.items.find(
        item => item.planid === action.payload.planid
      );
      
      if (existingItem) {
        existingItem.quantity += 1;
        NotifyMessageNoReload(`${action.payload.title} quantity increased`, "success", true);
      } else {
        state.items.push({ ...action.payload, quantity: 1 });
        NotifyMessageNoReload(`${action.payload.title} added to cart`, "success", true);
      }
      localStorage.setItem('redux_cart', JSON.stringify(state.items));
    },
    removeFromCart: (state, action) => {
      const removedItem = state.items.find(item => item.planid === action.payload);
      state.items = state.items.filter(item => item.planid !== action.payload);
      localStorage.setItem('redux_cart', JSON.stringify(state.items));
      if (removedItem) {
        NotifyMessageNoReload(`${removedItem.title} removed from cart`, "danger", true);
      }
    },
    updateQuantity: (state, action) => {
      const { planid, quantity } = action.payload;
      const item = state.items.find(item => item.planid === planid);
      
      if (item) {
        if (quantity <= 0) {
          state.items = state.items.filter(item => item.planid !== planid);
          NotifyMessageNoReload(`${item.title} removed from cart`, "danger", true);
        } else {
          const oldQuantity = item.quantity;
          item.quantity = quantity;
          if (oldQuantity < quantity) {
            NotifyMessageNoReload(`${item.title} quantity increased to ${quantity}`, "success", true);
          } else {
            NotifyMessageNoReload(`${item.title} quantity decreased to ${quantity}`, "warning", true);
          }
        }
      }
      localStorage.setItem('redux_cart', JSON.stringify(state.items));
    },
    clearCart: (state) => {
      const itemCount = state.items.length;
      state.items = [];
      localStorage.removeItem('redux_cart');
      if (itemCount > 0) {
        NotifyMessageNoReload("Cart cleared successfully", "success", true);
      }
    }
  }
});

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;

// Selectors
export const selectCartItems = (state) => state.cart.items;
export const selectCartTotal = (state) => 
  state.cart.items.reduce((total, item) => total + (item.selling_price * item.quantity), 0);
export const selectCartItemCount = (state) => 
  state.cart.items.reduce((count, item) => count + item.quantity, 0);

export default cartSlice.reducer;